var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5882 0.5H1.41176C0.635294 0.5 0.00705882 1.10268 0.00705882 1.83929L0 9.16072C0 9.89732 0.635294 10.5 1.41176 10.5H10.5882C11.3647 10.5 12 9.89732 12 9.16072V1.83929C12 1.10268 11.3647 0.5 10.5882 0.5ZM10.3059 3.34598L6.37412 6.3058C6.14824 6.43973 5.85177 6.43973 5.62588 6.3058L1.69412 3.34598C1.51765 3.23884 1.41176 3.05804 1.41176 2.86384C1.41176 2.41518 1.92706 2.14732 2.32941 2.3817L6 5.1875L9.67059 2.3817C10.0729 2.14732 10.5882 2.41518 10.5882 2.86384C10.5882 3.05804 10.4824 3.23884 10.3059 3.34598Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.114813465a234631be6a2c16e99c03bf.svg";
export { ForwardRef as ReactComponent };